import {OfferDisplayType} from "../../offer/helpers/OfferDisplayType";
import {IPropertyDetail} from "../types/IPropertyDetail";

export function isPropertyForSale(property: IPropertyDetail) {
    return property.offer.configuration.display_type === OfferDisplayType.FOR_SALE && property.for_sale;
}
import {OfferDisplayType} from "../../offer/helpers/OfferDisplayType";
import {IPropertyDetail} from "../types/IPropertyDetail";

export function isPropertyForSale(property: IPropertyDetail) {
    return property.offer.configuration.display_type === OfferDisplayType.FOR_SALE && property.for_sale;
}
